export default "mutation RequestSponsorshipForm($request: RequestSponsorshipFormInput!) {\n    requestSponsorshipForm(request: $request)\n}";